import Axios from 'axios'

const http = Axios.create()

export default {
  data: function() {
    return {
      working: false,
    }
  },
  methods: {
    getBookmark: function(magazineUrl, issueId, containerId) {
      if (this._bookmark) return this._bookmark
      this._bookmark = http.get(magazineUrl, {
        params: {
          issue_id: issueId,
          container_id: containerId
        }
      })
      return this._bookmark
    },
    hasBookmark: function(...args) {
      return this.getBookmark(...args)
        .then((bookmark) => !!bookmark.data)
    },
    createBookmark: function(urlName, issueId, containerId) {
      return Promise.resolve()
        .then(() => {
          if (this.working) throw new Error('is working')
          this.working = true
          const timestamp = new Date()
            .toISOString()
            .split('.')[0] + 'Z'
          const url = '/select/api/bookmarks/' + urlName
          return http.post(url, {
            issue_id: issueId,
            container_id: containerId,
            timestamp
          })
        })
        .then((result) => {
          this.working = false
          return result
        })
    }
  }
}
